import { api } from "@/api"

type ValidateMerchantGroupPasswordResetTokenResponse = {
  email: string
}

export const validateMerchantGroupPasswordResetToken =
  async (token: string) => {
    const { body } =
      await api.post<ValidateMerchantGroupPasswordResetTokenResponse>(
        "/merchant-group/validate-password-reset-token/",
        { body: { token }, authenticated: false }
      )
    return body
  }
